import { initialMembersState } from 'redux/initialState';
import { status } from 'constants/general';
import { transactionsTabsOptions } from 'constants/members';
import membersActionTypes from './action-types';
import membersStrings from './strings';

const membersReducer = (state = initialMembersState, { type, payload }) => {
  switch (type) {
    case membersActionTypes.FETCH_MEMBERS:
      return {
        ...state,
        membersList: {
          status: status.FETCHING,
        },
      };

    case membersActionTypes.FETCH_MEMBERS_SUCCESS:
      return {
        ...state,
        membersList: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case membersActionTypes.FETCH_MEMBERS_FAIL:
      return {
        ...state,
        membersList: {
          status: status.FAIL,
        },
      };

    case membersActionTypes.FETCH_MEMBER:
      return {
        ...state,
        member: {
          status: status.FETCHING,
        },
      };

    case membersActionTypes.FETCH_MEMBER_SUCCESS:
      return {
        ...state,
        member: {
          status: status.SUCCESS,
          details: payload,
        },
      };

    case membersActionTypes.FETCH_MEMBER_FAIL:
      return {
        ...state,
        member: {
          status: status.FAIL,
        },
      };

    case membersActionTypes.UPDATE_USER_BLOCK_STATUS:
      return {
        ...state,
        member: {
          ...state.member,
          blockingStatus: status.FETCHING,
        },
      };

    case membersActionTypes.UPDATE_USER_BLOCK_STATUS_SUCCESS:
      return {
        ...state,
        member: {
          ...state.member,
          blockingStatus: status.SUCCESS,
          snackBarMessage: payload.confirmationMessage,
          details: {
            ...state.member.details,
            data: { ...state.member.details.data, isBlocked: payload.isBlocked },
          },
        },
      };

    case membersActionTypes.UPDATE_USER_BLOCK_STATUS_FAIL:
      return {
        ...state,
        member: {
          ...state.member,
          blockingStatus: status.FAIL,
          snackBarMessage: membersStrings.memberProfile.failMessage,
        },
      };

    case membersActionTypes.FETCH_MEMBER_TRANSACTIONS: {
      // selected tab
      const transactionTabOption = transactionsTabsOptions.find(
        item => item.value === payload.transactionType,
      );
      const newList = { ...state.memberTransactionsList };
      newList[transactionTabOption.key] = {
        status: status.FETCHING,
        details: state.memberTransactionsList[transactionTabOption.key]?.details || {},
      };
      return {
        ...state,
        memberTransactionsList: newList,
      };
    }

    case membersActionTypes.FETCH_MEMBER_TRANSACTIONS_SUCCESS: {
      // selected tab
      const transactionTabOption = transactionsTabsOptions.find(
        item => item.value === payload.transactionType,
      );
      const prevStateTransactionData =
        state.memberTransactionsList[transactionTabOption.key]?.details?.data || [];
      const newData = prevStateTransactionData.concat(payload?.data || []);
      const newPayload = { ...payload };
      newPayload.data = newData;
      const newList = { ...state.memberTransactionsList };
      newList[transactionTabOption.key] = {
        status: status.SUCCESS,
        details: newPayload,
      };
      return {
        ...state,
        memberTransactionsList: newList,
      };
    }

    case membersActionTypes.FETCH_MEMBER_TRANSACTIONS_FAIL:
      return {
        ...state,
        memberTransactionsList: {
          status: status.FAIL,
        },
      };

    case membersActionTypes.SET_FILTERED_MEMBER_TRANSACTIONS:
      return {
        ...state,
        memberTransactionsFilteredList: {
          data: payload,
        },
      };

    case membersActionTypes.UPDATE_USER_POINTS:
      return {
        ...state,
        member: {
          ...state.member,
          updatingPointsStatus: status.FETCHING,
        },
      };

    case membersActionTypes.UPDATE_USER_POINTS_SUCCESS:
      return {
        ...state,
        member: {
          ...state.member,
          updatingPointsStatus: status.SUCCESS,
          snackBarMessage: payload.confirmationMessage,
          details: {
            ...state.member.details,
            data: { ...state.member.details.data, awardedPoints: payload.awardedPoints },
          },
        },
      };

    case membersActionTypes.UPDATE_USER_POINTS_FAIL:
      return {
        ...state,
        member: {
          ...state.member,
          updatingPointsStatus: status.FAIL,
          snackBarMessage: membersStrings.memberProfile.failMessage,
        },
      };

    case membersActionTypes.ADD_USER_SUCCESS:
      return {
        ...state,
        membersList: {
          ...state.membersList,
          addUserStatus: status.SUCCESS,
          snackBarMessage: payload.confirmationMessage,
        },
      };

    case membersActionTypes.ADD_USER_FAIL:
      return {
        ...state,
        membersList: {
          ...state.membersList,
          addUserStatus: status.FAIL,
          snackBarMessage: membersStrings.memberProfile.failMessage,
        },
      };

    case membersActionTypes.RESET_MEMBER_TRANSACTION:
      return {
        ...state,
        memberTransactionsList: {
          status: status.SHOULD_CALL_API,
          details: {},
        },
      };

    default:
      return state;
  }
};

export default membersReducer;
